import React from "react";

export const RecaudoContext = React.createContext();